import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const authApi = createApi({
  reducerPath: 'auth',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['users'],
  endpoints: (builder) => ({

    register: builder.mutation({
      query: (data) => ({
        url: '/api/users/register',
        method: 'POST',
        body: data,
      }),
    }),

    login: builder.mutation({
      query: (data) => {
        // console.log("Data sent to login API:", data); 
        return {
          url: '/api/users/login',
          method: 'POST',
          body: data,
        };
      },
    }),

    forgotPassword: builder.mutation({
      query: (data) => ({
        url: `/api/users/forgot-password`,
        method: 'POST',
        body: data,
      }),
    }),

    verifyAccount: builder.mutation({
      query: (data) => ({
        url: `/api/users/verify`,
        method: 'POST',
        body: data,
      }),
    }),


    resetPassword: builder.mutation({
      query: (data) => ({
        url: `/api/users/reset-password`,
        method: 'POST',
        body: data,
      }),
    }),


    getInfo: builder.query({
      query: () => ({
        url: `/api/users/user-info`,
        method: 'GET',
      }),
    }),


    templatedata: builder.query({
      query: ({ year, month }) => ({
        url: `/api/bulk/get-bulk-data`,
        method: 'GET',
      }),
    }),


    changePassword: builder.mutation({
      query: (data) => ({
        url: `/auth/resetPassword`,
        method: 'PUT',
        body: data,
      }),
    }),

    verifyEmail: builder.mutation({
      query: (data) => ({
        url: `/auth/verify`,
        method: 'POST',
        body: data,
      }),
    }),

 
    verifyUserDocument: builder.mutation({
      query: (fileData) => {
          // Create FormData object
          console.log("fileData", fileData);
          const formData = new FormData();
          formData.append("verificationFile", fileData);

          return {
             url: `/api/users/verify-user`,            // API endpoint for file upload
              method: 'POST',
              body: formData, // Send the FormData object as the body
          };
      },
  }),

    reSendOtp: builder.mutation({
      query: (data) => ({
        url: `/api/users/resend-verify-otp`,
        method: 'POST',
        body: data,
      }),
    }),

    logout: builder.mutation({
      query: (data) => ({
        url: `/api/users/logout`,
        method: 'POST',
        body: data,
      }),
    }),

  }),
});

export const {
  useForgotPasswordMutation,
  useRegisterMutation,
  useChangePasswordMutation,
  useVerifyEmailMutation,
  useResetPasswordMutation,
  useLoginMutation,
  useVerifyAccountMutation,
  useLogoutMutation,
  useTemplatedataQuery,
  useReSendOtpMutation,
  useVerifyUserDocumentMutation,
} = authApi;
